<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import { call, get } from "vuex-pathify"
import Toastification from "./components/ui/Toastification"

export default {
  name: "App",
  computed: {
    ...get("app", ["apiResponseState"]),
    ...get("notification", ["errorMessage", "successMessage"]),
  },
  methods: {
    ...call("notification", ["clearErrorMessage", "clearSuccessMessage"]),
    showError(title, message, timeout = 7000, debug = null) {
      this.$toast.error(
        {
          component: Toastification,
          props: {
            title,
            text: message,
            debug,
          },
        },
        { timeout }
      )
    },
    showSuccess(title, message, timeout = 7000) {
      this.$toast.success(
        {
          component: Toastification,
          props: {
            title,
            text: message,
          },
        },
        { timeout }
      )
    },
  },
  watch: {
    apiResponseState(response) {
      if (response.status === 500) {
        this.showError(
          "Chyba aplikace",
          "Vyskytla se chyba a úkol tak nemohl být dokončen.",
          10000,
          response.data.exception.message
        )
      }
    },
    errorMessage(errorMessage) {
      if (errorMessage) {
        this.showError(errorMessage.title, errorMessage.message)
        this.clearErrorMessage()
      }
    },
    successMessage(successMessage) {
      if (successMessage) {
        this.showSuccess(successMessage.title, successMessage.message)
        this.clearSuccessMessage()
      }
    },
  },
  mounted() {
    // console.log("App mounted")
  },
}
</script>

<style lang="sass">
@import './scss/main.scss'
</style>
